module.exports = __webpack_public_path__ + "static/media/pdbMenuFoldOut2_Tablet.6f84cdf4.png";